import { COOKIE_CONSENT_TOGGLE_KEYS } from '../constants/cookieConsent.constants';
import {
	CookieConsentToggleContent,
	CookieConsentToggleDescription,
	CookieConsentToggleLabel,
	CookieConsentToggleRow,
	CookieConsentToggleSwitch,
	CookieConsentToggles,
} from '../CookieConsent.styles';

const CookieConsentCustomizeToggles = ({ translations, choices, onToggle }) => (
	<CookieConsentToggles>
		<CookieConsentToggleRow $checked $locked>
			<CookieConsentToggleContent>
				<CookieConsentToggleLabel $checked>
					{translations.necessary}
				</CookieConsentToggleLabel>
				<CookieConsentToggleDescription>
					{translations.necessaryDescription}
				</CookieConsentToggleDescription>
			</CookieConsentToggleContent>
			<CookieConsentToggleSwitch $checked />
		</CookieConsentToggleRow>
		{COOKIE_CONSENT_TOGGLE_KEYS.map((key) => (
			<CookieConsentToggleRow
				key={key}
				$checked={choices[key]}
				onClick={() => onToggle(key)}
			>
				<CookieConsentToggleContent>
					<CookieConsentToggleLabel $checked={choices[key]}>
						{translations[key]}
					</CookieConsentToggleLabel>
					<CookieConsentToggleDescription>
						{translations[`${key}Description`]}
					</CookieConsentToggleDescription>
				</CookieConsentToggleContent>
				<CookieConsentToggleSwitch $checked={choices[key]} />
			</CookieConsentToggleRow>
		))}
	</CookieConsentToggles>
);

export default CookieConsentCustomizeToggles;
